import { jsx as o } from "react/jsx-runtime";
import { useCallback as m } from "react";
import { Select as i } from "antd";
import { u as p } from "../../styled-components.browser.esm-BFmoFexH.js";
const x = ({ value: e, canRemove: c, onChange: l, viewsWithMetrics: a, ...n }) => {
  const t = a[0], s = m(
    (r) => {
      l(r ? {
        metricCode: r,
        viewCode: t == null ? void 0 : t.code,
        viewAlias: t == null ? void 0 : t.alias,
        additionalFilters: [],
        titlePartOverrides: {}
      } : null);
    },
    [l, t]
  );
  return /* @__PURE__ */ o(h, { ...n, showSearch: !0, allowClear: c, optionFilterProp: "children", value: (e == null ? void 0 : e.metricCode) ?? null, onChange: s, virtual: !1, children: t == null ? void 0 : t.metrics.map(({ alias: r, code: d }) => /* @__PURE__ */ o(i.Option, { children: r }, d)) });
}, h = p(i)`
  width: 100%;
`;
export {
  x as default
};
//# sourceMappingURL=MetricSelectorSelect.js.map
